import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/passenger_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  email_cont: {
    model_name: 'Passenger',
    column_type: 'string',
    column_name: 'email',
  },
  first_name_cont: {
    model_name: 'Passenger',
    column_type: 'string',
    column_name: 'firstName',
  },
  last_name_cont: {
    model_name: 'Passenger',
    column_type: 'string',
    column_name: 'lastName',
  },
  phone_cont: {
    model_name: 'Passenger',
    column_type: 'string',
    column_name: 'phone',
  },
  passenger_type_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Passenger',
      options: ['adult', 'senior', 'youth', 'child'],
    },
    model_name: 'Passenger',
    column_name: 'passengerType',
  },
  user_id_eq: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
    },
    model_name: 'Passenger',
  },
  user: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
    },
    model_name: 'Passenger',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Passenger', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Passenger', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
